// 예습화면 네비게이션 아래 내용

import { TAB_TYPE } from '@repo/design-system/index'
import React, { useRef } from 'react'
import 'react-reflex/styles.css'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { s_preparation } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { DATA_REF_KEY } from '../../../../modules/ids/e2e/student'
import { TAB } from '../../../materials/const'
import OneBody from './OneBody'
import SubTab from './SubTab'

interface TextbodyProps {
  lesson: any
  currentUser: any
  isReview: any
  currentTab: any
  setCurrentTab: any
  currentTabSub?: any
  setCurrentTabSub?: any
  ringleDocToken: any
  isEditable: any
  setIsEditable: any
  setTabData: any
  answer: any
  setAnswer: any
  lessonId?: any
  selectedShareState: any
  setSelectedShareState: any
  activeQuestionId: any
  setActiveQuestionId: any
  saveMoveSubTab: any
}

const UnifiedTextbody = React.memo(
  ({
    lesson,
    currentUser,
    isReview,
    currentTab,
    setCurrentTab,
    ringleDocToken,
    isEditable,
    setIsEditable,
    setTabData,
    answer,
    setAnswer,
    selectedShareState,
    setSelectedShareState,
    activeQuestionId,
    setActiveQuestionId,
    saveMoveSubTab,
    lessonId,
  }: TextbodyProps) => {
    const iframeRef = useRef(null)
    const materialRef = useRef(null)
    const { t } = useTranslation()
    const isWebview = useIsWebview()
    const isFreeTalking = lesson?.course?.free_talking

    const UNIFIED_SUB_TABS = () => {
      const options = []

      options.push(
        // 인사이트 탭
        // (s)인사이트
        {
          dataRef: DATA_REF_KEY.btn_tab_insight,
          label: t(s_preparation.insight),
          key: TAB.INSIGHT,
        },
        // 자료 업로드 탭
        // ON 조건
        // - (s) 자유주제 수업일 때
        {
          label: t(s_preparation.document_submission),
          key: TAB.UPLOAD_FILE,
          none: !isFreeTalking,
        },
        // 링크 업로드 탭
        // ON 조건
        // - (t) 수업-링크 업로드 수업일때
        {
          label: t(s_preparation.btn_upload_link),
          key: TAB.UPLOAD_LINK,
          none: true,
        },
        {
          label: t(s_preparation.keyQuestion),
          key: TAB.QUESTION_SELECT,
          none: isFreeTalking,
        }
      )

      if (!isWebview) {
        options.push({
          label: <div className="relative flex items-start">{t(s_preparation.googleDocs)}</div>,
          key: TAB.NOTE,
        })
      }

      return options
    }

    return (
      <div className="relative h-full overflow-y-scroll">
        <SubTab
          SUB_MENU_LIST={UNIFIED_SUB_TABS()}
          activeTabIdx={currentTab}
          setActiveTabIdx={setCurrentTab}
          type={TAB_TYPE.SCROLL}
          lesson={lesson}
          currentUser={currentUser}
          isRightTab={false}
          saveMoveSubTab={saveMoveSubTab}
          isEditable={isEditable}
          setIsEditable={setIsEditable}
          answer={answer}
          activeQuestionId={activeQuestionId}
        />
        <OneBody
          lesson={lesson}
          material={lesson?.course}
          expressions={lesson?.expressions}
          isReview={isReview}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          materialRef={materialRef}
          setTabData={setTabData}
          iframeRef={iframeRef}
          currentUser={currentUser}
          isEditable={isEditable}
          setIsEditable={setIsEditable}
          answer={answer}
          setAnswer={setAnswer}
          selectedShareState={selectedShareState}
          setSelectedShareState={setSelectedShareState}
          activeQuestionId={activeQuestionId}
          setActiveQuestionId={setActiveQuestionId}
          lessonId={lessonId}
        />
      </div>
    )
  }
)

UnifiedTextbody.displayName = 'UnifiedTextbody'

export default UnifiedTextbody
